import React, { useEffect, useState } from 'react';
import { Outlet, useParams, Link, useLocation,useNavigate } from 'react-router-dom';
import Breadcrums from '../../common/breadcrumbs';
import * as eventsService from '../../services/events.services';
import { EVENT_TYPES } from '../../../../utils/Constants';

const View = (props) => {
  const params = useParams();  
  const navigate = useNavigate();
  const loc = useLocation();
  const [showdefault, setShowDefault] = useState({});

  useEffect(() => {
    eventsService.Details(params.id).then(response => {
      if (response && response.success) {
        setShowDefault(response.data ? response.data : [])
      }
    }).catch(error => {
      console.log("error=====>", error)
    })
  }, [params.id])


  const navigateToRegistrations=()=>{
    navigate(`/admin/event-management/events/view/registrations/${params?.id}/1`,{state:{...showdefault}});
  }

  const tabItems = [
    {
      key: "event",
      label: "Event",
      to: `/admin/event-management/events/view/event/${params?.id}`,
      isActive: loc.pathname === `/admin/event-management/events/view/event/${params?.id}`,
    },
    {
      key: "hotels",
      label: "Hotels",
      to: `/admin/event-management/events/view/hotels/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/hotels/${params?.id}`),
    },
    {
      key: "agenda",
      label: "Agenda",
      to: `/admin/event-management/events/view/agenda/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/agenda/${params?.id}`),
    },
    ...(showdefault.event_type === EVENT_TYPES.INVITATION_ONLY
      ? [{
          key: "invitations",
          label: "Invitations",
          to: `/admin/event-management/events/view/invitations/${params?.id}?page=1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/invitations/${params?.id}`),
        }]
      : []),
    {
      key: "registrations",
      label: "Registrations",
      onClick: navigateToRegistrations,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/registrations/${params?.id}`),
    },
    {
      key: "attendees",
      label: "Attendees",
      to: `/admin/event-management/events/view/attendees/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/attendees/${params?.id}`),
    },
    {
      key: "announcements",
      label: "Announcements",
      to: `/admin/event-management/events/view/event-announcements/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/event-announcements`),
    },
    {
      key: "checkin-checkout",
      label: "Checkin/Checkout",
      to: `/admin/event-management/events/view/checkIn-checkOut/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/checkIn-checkOut/${params?.id}`),
    },
    {
      key: "transactions",
      label: "Transactions",
      to: `/admin/event-management/events/view/event-transactions/${params?.id}/1`,
      isActive: loc.pathname.includes(`/admin/event-management/events/view/event-transactions/${params?.id}`),
    },
    ...(showdefault?.lead_management === true
      ? [{
          key: "leads",
          label: "Leads",
          to: `/admin/event-management/events/view/event-leads/${params?.id}/1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-leads/${params?.id}`),
        },
        {
          key: "lm-user-invitation",
          label: "LM User Invitation",
          to: `/admin/event-management/events/view/event-lm-user-invitation/${params?.id}/1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-lm-user-invitation/${params?.id}`),
        },
        {
          key: "lm-user-registration",
          label: "LM User Registration",
          to: `/admin/event-management/events/view/event-lm-user-registration-list/${params?.id}/1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-lm-user-registration-list/${params?.id}`),
        },
        {
          key: "drip-content",
          label: "Drip Content",
          to: `/admin/event-management/events/view/event-drip-content/${params?.id}?page=1&count_page=1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-drip-content/${params?.id}`),
        }]
      : []),
    ...(showdefault?.sis_management === true
      ? [{
          key: "sis-user-invitation",
          label: "SIS User Invitation",
          to: `/admin/event-management/events/view/event-sis-user-invitation/${params?.id}/1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-sis-user-invitation/${params?.id}`),
        },
        {
          key: "booth-attendants",
          label: "Booth Attendants",
          to: `/admin/event-management/events/view/event-booth-attendants/${params?.id}/1`,
          isActive: loc.pathname.includes(`/admin/event-management/events/view/event-booth-attendants/${params?.id}`),
        }]
      : []),
  ];

  const activeTabLabel = tabItems.find((item) => item.isActive)?.label || "Navigate";

  const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Events", url: "/admin/event-management/events/list/1" }, { title: "View", url: "" }];
  useEffect(() => {
    eventsService.Details(params.id).then(response => {
      if (response && response.success) {
        setShowDefault(response.data ? response.data : [])
      }
    }).catch(error => {
      console.log("error=====>", error)
    })
  }, [params.id])

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">{showdefault?.title}</h6>
              </div>
              <div className="tabs-wrap">
                <div className="profile-tab tab-menu-heading mb-4">
                  <div className="mb-3 d-xl-none">
                    <select
                      className="form-control cp"
                      value={tabItems.find((item) => item.isActive)?.key || ""}
                      onChange={(e) => {
                        const selectedTab = tabItems.find((item) => item.key === e.target.value);
                        if (!selectedTab) return;
                        if (selectedTab.to) {
                          navigate(selectedTab.to);
                          return;
                        }
                        if (selectedTab.onClick) {
                          selectedTab.onClick();
                        }
                      }}
                    >
                      {!activeTabLabel ? <option value="">Select section</option> : null}
                      {tabItems.map((item) => (
                        <option key={item.key} value={item.key}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100 d-none d-xl-flex flex-nowrap overflow-auto">
                    {tabItems.map((item) => (
                      item.to ? (
                        <Link
                          key={item.key}
                          className={`nav-link linkactive${item.isActive ? " active" : ""}`}
                          aria-current={item.isActive ? "page" : undefined}
                          to={item.to}
                        >
                          {item.label}
                        </Link>
                      ) : (
                        <a
                          key={item.key}
                          href="#!"
                          className={`nav-link linkactive cp${item.isActive ? " active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            item.onClick?.();
                          }}
                        >
                          {item.label}
                        </a>
                      )
                    ))}
                  </nav>
                </div>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default View;